import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import { FormSelect, DropdownWithGeolocate } from '@components/Common/AwpFormInputs';
import { HaversineDistance } from '@components/Avalanche/OccurrenceHelper';
import { propTypes } from 'react-bootstrap/esm/Image';

const RoadClosurePreferences = ({ programs, areas, segments, formikProps, dto }) => {
  const [areaList, setAreaList] = useState(areas);
  const [lineList, setLineList] = useState(segments);

  useEffect(() => {
    if (dto?.program) {
      setAreaList(areas.filter((x) => x.parentId === dto.program.value));
      setLineList(segments.filter((x) => x.programId === dto.program.value));
    }

    if (dto?.area) {
      setLineList(segments.filter((x) => x.areaId === dto.area.value));
    }
  }, [dto]);

  const addDistance = (e, setFieldValue, setFieldTouched) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const crd = pos.coords;

        //HaversineDistance = (lat1, long1, lat2, long2)
        const linesWithDistance = segments
          .map((p) => {
            if (p.latitude && p.longitude) {
              const dist = HaversineDistance(p.latitude, p.longitude, crd.latitude, crd.longitude);
              return { ...p, label: `${p.label} (${parseFloat(dist).toFixed(3).toString()}km)`, distanceAway: dist };
            } else {
              return { ...p, label: `${p.label} (No GPS data)`, distanceAway: 999999999 };
            }
          })
          .sort((a, b) => {
            return a.distanceAway - b.distanceAway;
          });

        setLineList(linesWithDistance);

        const closestLine = linesWithDistance.reduce((p, c) => {
          return p.distanceAway < c.distanceAway ? p : c;
        });

        if (closestLine) {
          setFieldValue('roadclosure.segment', closestLine);
          setFieldTouched('roadclosure.segment', true, true);
          segmentOnChange(closestLine, setFieldValue, linesWithDistance);
        }
      },
      (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
    );
  };

  const programOnChange = (opt, setFieldValue) => {
    setFieldValue('roadclosure.area', null, false);
    setAreaList(areas.filter((x) => x.parentId === opt.value));

    setFieldValue('roadclosure.segment', null, false);
    setLineList(segments.filter((x) => x.programId === opt.value));
  };

  const areaOnChange = (opt, setFieldValue) => {
    setFieldValue('roadclosure.segment', null, false);
    setLineList(segments.filter((x) => x.areaId === opt.value));

    setFieldValue(
      'roadclosure.program',
      programs.find((x) => x.value === opt.parentId),
    );
  };

  const segmentOnChange = (opt, setFieldValue, lines) => {
    const area = areas.find((x) => x.value === opt.areaId);
    setAreaList(areas.filter((x) => x.parentId === area.parentId));
    setFieldValue('roadclosure.area', area, false);

    const program = programs.find((x) => x.value === area.parentId);
    setFieldValue('roadclosure.program', program, false);

    setLineList((lines || segments).filter((x) => x.areaId === opt.areaId));
  };

  const handleReset = (formikProps) => {
    formikProps.setFieldValue('roadclosure.program', { value: '' }, false);
    formikProps.setFieldValue('roadclosure.area', { value: '' }, false);
    formikProps.setFieldValue('roadclosure.segment', { value: '' }, false);
    setAreaList(areas);
    setLineList(segments);
  };

  return (
    <>
      <Card border="light" className="page-card">
        <Card.Header as="h3" style={{ backgroundColor: 'transparent' }}>
          ROAD CLOSURE
        </Card.Header>
        <Card.Body>
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="roadclosure.program"
            id="roadclosure.program"
            label="Program"
            postChange={(e) => {
              programOnChange(e, formikProps.setFieldValue);
            }}
            options={programs}
            isMulti={false}
          />

          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="roadclosure.area"
            id="roadclosure.area"
            label="Avalanche Area"
            postChange={(e) => {
              areaOnChange(e, formikProps.setFieldValue);
            }}
            options={areaList}
            isMulti={false}
          />
          <DropdownWithGeolocate
            readOnly={false}
            name="roadclosure.segment"
            id="roadclosure.segment"
            label="Road Closure Area"
            postChange={(e) => {
              segmentOnChange(e, formikProps.setFieldValue);
            }}
            options={lineList}
            isMulti={false}
            buttonAction={(e) => {
              addDistance(e, formikProps.setFieldValue, formikProps.setFieldTouched);
            }}
            disableGPS={false}
          />
          <Button className="my-3" variant="outline-primary" onClick={() => handleReset(formikProps)}>
            Reset
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

RoadClosurePreferences.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  formikProps: PropTypes.object,
  dto: PropTypes.object,
};

export default RoadClosurePreferences;
